import { COVER_TO_CLASS_TYPE } from 'constants/domain-specific';
import { Cover, DynamicCoverQuestion, DynamicCoverQuestionID } from 'types/cover';

/**
 * @description
 * Returns a clauseCode if it exists under a specific dynamic cover question id
 * in the dynamicCoverQuestions result, which is stored from the Ref-Data API call.
 * They are grouped by cover, hence you should provide a cover in association with the questionID
 * to prevent question name collisions across multiple covers.
 * i.e. exampleSI could be common across Liability and Theft
 */
export const getDynamicCoverQuestionClauseCode = (
  dynamicCoverQuestions: DynamicCoverQuestion[],
  cover: Cover,
  questionID: DynamicCoverQuestionID
): string | undefined => {
  /**
   * @note the reason why we do this conversion instead of expecting user to just pass in classType
   * is because from the SPA perspective Cover is the source of truth throughout the codebase.
   * ClassType is a backend concept, and hence should be abstracted where possible throughout the codebase.
   *
   */
  const classType = COVER_TO_CLASS_TYPE[cover];
  const dynamicQuestions = dynamicCoverQuestions?.find((cq) => cq.cover === classType);

  if (!dynamicQuestions) return undefined;

  const clauseCode = dynamicQuestions.options.find((o) => o.questionId === questionID)?.clauseCode;

  if (clauseCode !== '') return clauseCode;

  return undefined;
};
